import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import http from 'http';
import Header from '../components/layout/Header';
import https from 'https';
import moment from 'moment';
import Cheque from './order/Cheque';
import Translate from './layout/Translate';
import OrderGeneral from './order/General'
import Clients from './order/Clients'
import Pay from './order/Pay'

import * as toursActions from '../actions/tours';
import * as orderActions from '../actions/order';

import Select from 'react-select';

// Be sure to include styles at some point, probably during your bootstrapping






class Order extends Component {

  componentWillMount() {
    this.orderProps = {
      order: 400,
      type: 'chronopay',
      prepayment: 1,
      currency: 'RUR'
    };

    this.props.toursActions.setMapConfig({active: false});
    //console.info(this.props);


    if (this.props.params.param_id) {
      this.props.orderActions.clearOrder();
      this.props.orderActions.selectDeparture(this.props.departure);
    }

    if (this.props.params.order_id) {
      this.props.orderActions.getClients(this.props.params.order_id);
      if (this.props.user.id) {
        this.props.orderActions.fetchOrderIfNeeded(this.props.params.order_id, this.props.user.id);
      }
    }

  }

  componentWillUpdate() {

    if (this.props.params.order_id && this.props.user.id && !this.props.order.props.order) {
      this.props.orderActions.fetchOrderIfNeeded(this.props.params.order_id, this.props.user.id);
    }

    //console.log(this.props.order);
    if (this.props.order.props.order && this.props.order.props.order.departures && !this.props.tour.id) {
      this.props.toursActions.fetchPostsIfNeeded(1, this.props.order.props.order.departures[0].program_id);
    }
  }


  componentDidUpdate () {
    let actions = this.props.orderActions;
    if (this.props.order.chronopay_promise) {
      this.props.order.chronopay_promise.then(function(test) {

        //console.log(test);
        actions.setProcessingLink(test);
      });
    }

    if (this.props.order.order_promise) {
      this.props.order.order_promise.then(function(result) {

        actions.setOrderProps(result);
      });
    }


    if (this.props.tour.programDays && !this.props.order.options) {

      let options = [];
      this.props.tour.programDays.forEach(function (day) {
        day.programServices.forEach(function (service) {
          if (service.is_option && service.price) {
            service.count = 0;
            options.push(service);
          }
        });
      });

      this.props.orderActions.setOptions(options);
    }
    
  }



  setProps(key, e) {
    this.orderProps[key] = e.target.value;
    this.props.setOrderProps(this.orderProps);
  }

  render () {

    let user = (this.props.order.user.email)?this.props.order.user:this.props.user;
    let {tour} = this.props;
    let {departure} = this.props.order;
    let order = this.props.order;

    

    tour.options = [];



    moment.locale('ru');
    if (tour.departures) {
      let minDate = 0;
      let maxDate = 0;
      let minPrice = 0;
      tour.departures.sort(function (a, b) {
        if (a.start_at > b.start_at) {
          return 1;
        }
        if (a.start_at < b.start_at) {
          return -1;
        }
        return 0;
      });
      tour.departures.forEach(function (departure) {
        departure.now_date = new Date();
        departure.now_moment = moment(departure.now_date.getTime());

        departure.start_date = new Date(departure.start_at * 1000);
        departure.start_date_6 = new Date(departure.start_at * 1000);
        departure.start_date_6.setMonth(departure.start_date.getMonth()-6);

        departure.start_date_8 = new Date(departure.start_at * 1000);
        departure.start_date_8.setMonth(departure.start_date.getMonth()-8);

        departure.start_date_10 = new Date(departure.start_at * 1000);
        departure.start_date_10.setMonth(departure.start_date.getMonth()-10);

        departure.end_date = new Date(departure.end_at * 1000);
        departure.start_moment = moment(departure.start_at * 1000);
        departure.end_moment = moment(departure.end_at * 1000);
        departure.formated_start_date = departure.start_moment.format('D MMMM YYYY');
        departure.formated_end_date = departure.end_moment.format('D MMMM YYYY');
        departure.month_diff = departure.start_moment.diff(departure.now_moment, 'months');
        departure.diff = departure.start_moment.diff(departure.now_moment);


        if (!minDate || departure.start_at < minDate) {
          minDate = departure.start_at;
        }

        if (!maxDate || departure.end_at > maxDate) {
          maxDate = departure.end_at;
        }

        if (!minPrice || departure.price > minPrice) {
          minPrice = departure.price;
        }

      });
      this.minMonth = new Date(minDate*1000).toLocaleString('ru', {
        month: 'long'
      });
      this.maxMonth = new Date(maxDate*1000).toLocaleString('ru', {
        month: 'long'
      });
      this.minPrice = minPrice;
    }


    return (
      <div>
        <section className="section section__page main">

          <Header />
          <div className="container order page">
            {order.step == 0 &&
            <div className="container__content">
              <div className="order__steps">
                <div className="order__line"></div>
                <div>
                  <div className="order__step order__step_active">1</div>
                  <div className="order__step ">2</div>
                  <div className="order__step">3</div>
                </div>
              </div>
              <div className="order__title">
                <Translate slug="order__step-1__title" />
              </div>
              <OrderGeneral order={order} tour={tour} actions={this.props.orderActions} user={user}/>
            </div>
            }

            {order.step == 1 &&
            <div className="container__content">
              <div className="order__steps">
                <div className="order__line"></div>
                <div>
                  <div className="order__step order__step_complete">1</div>
                  <div className="order__step order__step_active">2</div>
                  <div className="order__step">3</div>
                </div>
              </div>
              <div className="order__title">
                <Translate slug="order__step-2__title" />
              </div>
              <Clients order={order} tour={tour} actions={this.props.orderActions} user={user} />
            </div>
            }

            {order.step == 2 &&
            <div className="container__content">
                <div className="order__steps">

                  <div className="order__line"></div>
                  <div>
                    <div className="order__step order__step_complete">1</div>
                    <div className="order__step order__step_complete">2</div>
                    <div className="order__step order__step_active">3</div>
                  </div>
                </div>

                <div className="order__title">
                  <Translate slug="order__step-3__title" />
                </div>
                <Pay order={order} tour={tour} actions={this.props.orderActions} user={user}/>


            </div>
            }
            

            <div className="container__sidebar container__sidebar_align_right">
              <Cheque order={order} tour={tour} actions={this.props.orderActions} />
            </div>




          </div>



          <div className="container order" style={{display: 'none'}}>

            <div className="section__content">

              <div>
                {Object.keys(this.props.order.props).map((key) =>

                    <input key={key} type="text" name={key} value={this.props.order.props[key]} onChange={this.setProps.bind(this, key)} />
                )}

                <br/>
                {(this.props.order.chronopay_info  && this.props.order.chronopay_info.result && this.props.order.chronopay_info.result.link) &&
                <form target="_blank" action={this.props.order.chronopay_info.result.link} method="post">
                  {Object.keys(this.props.order.chronopay_info.result.params).map((key) =>

                      <input key={key} type="text" name={key} value={this.props.order.chronopay_info.result.params[key]} />
                  )}
                  <input type="submit" value="Go"/>
                </form>
                }

              </div>
            </div>
            <div className="container__sidebar container__sidebar_align_right"></div>
          </div>


        </section>


      </div>
    );
  }
}

Order.need = [
  {
    action: toursActions.fetchPosts
  }
];

export default Order;


// WEBPACK FOOTER //
// ./src/common/components/Order.js